import { Flex, Popconfirm, Switch } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaPlusCircle, FaRegTrashAlt } from 'react-icons/fa';
import Avatar from '~/components/Avatar';
import Button from '~/components/Button';
import Can from '~/components/Can';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';

export const employeesColumns = (handleEdit, handleDelete, handleActive, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (text, record) => (
          <div>
            <Strong>{i18next.t('screens:default.name')}:</Strong> {record?.name}
            <br />
            <Strong>{i18next.t('Email')}:</Strong> {record?.email}
            <br />
            <Strong>{i18next.t('screens:default.city')}:</Strong> {record?.city?.name}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@employees/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@employees/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t(''),
      dataIndex: 'avatar_url',
      key: 'avatar_url',
      width: '1%',
      render: (text, record) => <Avatar size="50px" image={record.avatar_url} />,
    },
    {
      title: i18next.t('screens:default.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => record.name,
    },
    {
      title: i18next.t('Email'),
      dataIndex: 'email',
      key: 'email',
      render: (text, record) => record.email,
    },
    {
      title: i18next.t('screens:default.city'),
      dataIndex: 'cidade',
      key: 'cidade',
      render: (text, record) => record.city?.name,
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (text, record) => (
        <TableActions align="center" justify="center">
          <Can permission="@employees/edit">
            <Switch
              size="small"
              checked={record?.active}
              title={record?.active ? 'Desativar' : 'Ativar'}
              onClick={() => handleActive(record?.id, record?.active)}
            >
              <FaPencilAlt />
            </Switch>
          </Can>
          <Button style={{ margin: 'auto' }} size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@employees/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@employees/delete">
            <Popconfirm
              data-noclickable="true"
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};

export const employeesImportColumns = (handleAddEmployee, isMobile, employeeIdsInEvent) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <p>
              <Strong>{i18next.t('screens:Nome')}:</Strong> {record.name}
            </p>
            <p>
              <Strong>{i18next.t('screens:Email')}:</Strong> {record.email}
            </p>
            <p>
              <Strong>{t('screens:Cidade')}:</Strong> {record.city_id ? record.city_name + '/' + record.state_name : ''}
            </p>
            <Can permission="@events/edit">
              <TableActions align="center" justify="center">
                <Button
                  size="medium"
                  title="Adicionar"
                  onClick={() => handleAddEmployee(record.id, record.name, record.phone)}
                >
                  <FaPlusCircle />
                </Button>
              </TableActions>
            </Can>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => record.name,
    },
    {
      title: i18next.t('screens:Email'),
      dataIndex: 'email',
      key: 'email',
      render: (text, record) => record.email,
    },
    {
      title: i18next.t('screens:Cidade'),
      dataIndex: 'city',
      key: 'city',
      render: (text, record) => (record.city_id ? record.city_name + '/' + record.state_name : ''),
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (text, record) => (
        <Can permission="@events/edit">
          <Flex align="center" justify="center">
            <Button
              size="small"
              style={{ width: '30px' }}
              title="Adicionar"
              onClick={() => handleAddEmployee(record?.id, record?.name, record?.phone)}
              disabled={record?.in_event || employeeIdsInEvent?.includes(record?.id)}
            >
              <FaPlusCircle />
            </Button>
          </Flex>
        </Can>
      ),
    },
  ];
};
